import { Card, Divider } from "@mui/material";
import MDBadge from "components/MDBadge";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import SkLoading from "components/SkLoading";
import SwiperSlider from "components/SkSlider/Swiper";
import { useMaterialUIController } from "context";
import React from "react";
import { useSelector } from "react-redux";
import { SwiperSlide } from "swiper/react";
import { SkPrice } from "Utils/dateFunc";
import { formattedDateServer } from "Utils/dateFunc";
import DOMPurify from "dompurify";

const EproductDeails = () => {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const { Loading, HomeProduct, singleHomeProduct } = useSelector((state) => ({
    ...state.isEHomeProduct,
  }));
  // console.log(singleHomeProduct, "singleHomeProduct");
  return (
    <>
      <MDBox
        display="flex"
        alignItems="center"
        lineHeight={1}
        sx={{
          justifyContent: "center",
          flexDirection: "column",
          gap: 2,
          width: "100%",
        }}
      >
        <Card
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 , 10px",
          }}
        >
          <MDTypography variant="h6" py={0.9}>
           E- Home Product Details
          </MDTypography>
        </Card>
        {Loading ? (
          <SkLoading />
        ) : (
          <MDBox
            display="flex"
            alignItems="center"
            lineHeight={1}
            sx={({ palette: { dark, white, info } }) => ({
              border: 0.5,
              borderColor: darkMode ? white.main : dark.main,
              borderRadius: 3,
              p: 2,
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              gap: 2,
            })}
          >
            <MDBox
              sx={({ palette: { dark, white, info } }) => ({
                width: "100%",
                height: "auto",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                gap: 1.5,
              })}
            >
              <MDBox
                sx={({ palette: { dark, white, info }, breakpoints }) => ({
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "space-between",
                  width: "100%",
                  gap: 3,
                  [breakpoints.up("xs")]: {
                    px: 1,
                  },
                  [breakpoints.up("sm")]: {
                    px: 1,
                  },
                  [breakpoints.up("md")]: {
                    px: 6,
                  },
                  [breakpoints.up("lg")]: {
                    px: 6,
                  },
                })}
              >
                <MDTypography variant="h6" sx={{ minWidth: "200px", flexShrink: 0, whiteSpace: "nowrap", textAlign: "left" }}>
                  Title :
                </MDTypography>
                <MDTypography
                  variant="h6"
                  sx={{
                    overflow: "hidden",
                    wordBreak: "break-word",
                    textAlign: "right",
                    maxWidth: "70%",
                  }}
                >
                  {singleHomeProduct?.title || "-"}
                </MDTypography>
              </MDBox>
              <MDBox
                sx={({ palette: { dark, white, info }, breakpoints }) => ({
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "space-between",
                  width: "100%",
                  gap: 3,
                  [breakpoints.up("xs")]: {
                    px: 1,
                  },
                  [breakpoints.up("sm")]: {
                    px: 1,
                  },
                  [breakpoints.up("md")]: {
                    px: 6,
                  },
                  [breakpoints.up("lg")]: {
                    px: 6,
                  },
                })}
              >
                <MDTypography variant="h6" sx={{ minWidth: "200px", flexShrink: 0, whiteSpace: "nowrap", textAlign: "left" }}>
                  Description :
                </MDTypography>
                <MDTypography
                  variant="h6"
                  sx={{
                    overflow: "hidden",
                    wordBreak: "break-word",
                    textAlign: "left",
                    maxWidth: "70%",
                  }}
                >
                  {singleHomeProduct?.description || "-"}
                </MDTypography>
              </MDBox>

              {singleHomeProduct?.products && singleHomeProduct?.products.map((ele, i) => (
                <React.Fragment key={i}>
                  <hr style={{ width: "100%" }} />
                  <MDTypography variant="h6"> Product {i + 1} </MDTypography>
                  <MDBox
                    sx={({ palette: { dark, white, info }, breakpoints }) => ({
                      display: "flex",
                      alignItems: "flex-start",
                      justifyContent: "space-between",
                      width: "100%",
                      gap: 3,
                      [breakpoints.up("xs")]: {
                        px: 1,
                      },
                      [breakpoints.up("sm")]: {
                        px: 1,
                      },
                      [breakpoints.up("md")]: {
                        px: 6,
                      },
                      [breakpoints.up("lg")]: {
                        px: 6,
                      },
                    })}
                  >
                    <MDTypography variant="h6" sx={{ minWidth: "200px", flexShrink: 0, whiteSpace: "nowrap", textAlign: "left" }}>
                      Product Title :
                    </MDTypography>
                    <MDTypography
                      variant="h6"
                      sx={{
                        overflow: "hidden",
                        wordBreak: "break-word",
                        textAlign: "right",
                        maxWidth: "70%",
                      }}
                    >
                      {ele?.title || "-"}
                    </MDTypography>
                  </MDBox>
                  <MDBox
                    sx={({ palette: { dark, white, info }, breakpoints }) => ({
                      display: "flex",
                      alignItems: "flex-start",
                      justifyContent: "space-between",
                      width: "100%",
                      gap: 3,
                      [breakpoints.up("xs")]: {
                        px: 1,
                      },
                      [breakpoints.up("sm")]: {
                        px: 1,
                      },
                      [breakpoints.up("md")]: {
                        px: 6,
                      },
                      [breakpoints.up("lg")]: {
                        px: 6,
                      },
                    })}
                  >
                    <MDTypography variant="h6" sx={{ minWidth: "200px", flexShrink: 0, whiteSpace: "nowrap", textAlign: "left" }}>
                      Products Description :
                    </MDTypography>
                    <MDBox
                      sx={{
                        width: "100%",
                        maxWidth: "70%",
                        textAlign: "left",
                        "& p": { m: 0, mb: 1, lineHeight: "24px" },
                        "& ul, & ol": { pl: 2.5, m: 0, mb: 1 },
                        "& li": { mb: 0.5, lineHeight: "24px" },
                        "& h1, & h2, & h3, & h4, & h5, & h6": { mb: 1, mt: 1 },
                        "& table": {
                          width: "100%",
                          borderCollapse: "collapse",
                          my: 1.5,
                          borderRadius: "8px",
                          overflow: "hidden",
                          border: darkMode ? "1px solid rgba(255, 255, 255, 0.15)" : "1px solid rgba(0, 0, 0, 0.12)",
                        },
                        "& th, & td": {
                          border: darkMode ? "1px solid rgba(255, 255, 255, 0.12)" : "1px solid rgba(0, 0, 0, 0.1)",
                          padding: "8px 12px",
                          fontSize: "0.85rem",
                          lineHeight: "1.5",
                          textAlign: "left",
                          verticalAlign: "top",
                        },
                        "& th": {
                          fontWeight: 700,
                          backgroundColor: darkMode ? "rgba(255, 255, 255, 0.08)" : "rgba(0, 0, 0, 0.05)",
                        },
                        "& tr:nth-of-type(even)": {
                          backgroundColor: darkMode ? "rgba(255, 255, 255, 0.03)" : "rgba(0, 0, 0, 0.02)",
                        },
                        "& tr:hover": {
                          backgroundColor: darkMode ? "rgba(255, 255, 255, 0.06)" : "rgba(0, 0, 0, 0.04)",
                        },
                      }}
                    >
                      <MDTypography
                        variant="body2"
                        sx={{
                          textAlign: "left",
                          wordBreak: "break-word",
                          lineHeight: "24px",
                        }}
                        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(ele?.description || "-") }}
                      />
                    </MDBox>
                  </MDBox>
                  <MDBox
                    sx={({ palette: { dark, white, info }, breakpoints }) => ({
                      display: "flex",
                      alignItems: "flex-start",
                      justifyContent: "space-between",
                      width: "100%",
                      gap: 3,
                      [breakpoints.up("xs")]: {
                        px: 1,
                      },
                      [breakpoints.up("sm")]: {
                        px: 1,
                      },
                      [breakpoints.up("md")]: {
                        px: 6,
                      },
                      [breakpoints.up("lg")]: {
                        px: 6,
                      },
                    })}
                  >
                    <MDTypography variant="h6" sx={{ minWidth: "200px", flexShrink: 0, whiteSpace: "nowrap", textAlign: "left" }}>
                      Products Subtitle :
                    </MDTypography>
                    <MDTypography
                      variant="h6"
                      sx={{
                        overflow: "hidden",
                        wordBreak: "break-word",
                        textAlign: "right",
                        maxWidth: "70%",
                      }}
                    >
                      {ele?.subtitle || "-"}
                    </MDTypography>
                  </MDBox>
                  <MDBox
                    sx={({ palette: { dark, white, info }, breakpoints }) => ({
                      display: "flex",
                      alignItems: "flex-start",
                      justifyContent: "space-between",
                      width: "100%",
                      gap: 3,
                      [breakpoints.up("xs")]: {
                        px: 1,
                      },
                      [breakpoints.up("sm")]: {
                        px: 1,
                      },
                      [breakpoints.up("md")]: {
                        px: 6,
                      },
                      [breakpoints.up("lg")]: {
                        px: 6,
                      },
                    })}
                  >
                    <MDTypography variant="h6" sx={{ minWidth: "200px", flexShrink: 0, whiteSpace: "nowrap", textAlign: "left" }}>
                      Products Price :
                    </MDTypography>
                    <MDTypography
                      variant="h6"
                      sx={{
                        textAlign: "right",
                        maxWidth: "70%",
                      }}
                    >
                      {ele?.price !== undefined && ele?.price !== null && ele?.price !== ""
                        ? (typeof ele?.price === "number" || !isNaN(Number(ele?.price))
                            ? SkPrice(ele?.price)
                            : ele?.price)
                        : "-"}
                    </MDTypography>
                  </MDBox>
                  <MDBox
                    sx={({ palette: { dark, white, info }, breakpoints }) => ({
                      display: "flex",
                      alignItems: "flex-start",
                      justifyContent: "space-between",
                      width: "100%",
                      gap: 3,
                      [breakpoints.up("xs")]: {
                        px: 1,
                      },
                      [breakpoints.up("sm")]: {
                        px: 1,
                      },
                      [breakpoints.up("md")]: {
                        px: 6,
                      },
                      [breakpoints.up("lg")]: {
                        px: 6,
                      },
                    })}
                  >
                    <MDTypography variant="h6" sx={{ minWidth: "200px", flexShrink: 0, whiteSpace: "nowrap", textAlign: "left" }}>
                      Products MRP :
                    </MDTypography>
                    <MDTypography
                      variant="h6"
                      sx={{
                        textAlign: "right",
                        maxWidth: "70%",
                      }}
                    >
                      {ele?.mrp !== undefined && ele?.mrp !== null && ele?.mrp !== ""
                        ? (typeof ele?.mrp === "number" || !isNaN(Number(ele?.mrp))
                            ? SkPrice(ele?.mrp)
                            : ele?.mrp)
                        : "-"}
                    </MDTypography>
                  </MDBox>
                  <MDBox
                    sx={({ palette: { dark, white, info }, breakpoints }) => ({
                      display: "flex",
                      alignItems: "flex-start",
                      justifyContent: "space-between",
                      width: "100%",
                      gap: 3,
                      [breakpoints.up("xs")]: {
                        px: 1,
                      },
                      [breakpoints.up("sm")]: {
                        px: 1,
                      },
                      [breakpoints.up("md")]: {
                        px: 6,
                      },
                      [breakpoints.up("lg")]: {
                        px: 6,
                      },
                    })}
                  >
                    <MDTypography variant="h6" sx={{ minWidth: "200px", flexShrink: 0, whiteSpace: "nowrap", textAlign: "left" }}>
                      Products Sold :
                    </MDTypography>
                    <MDTypography
                      variant="h6"
                      sx={{
                        textAlign: "right",
                        maxWidth: "70%",
                      }}
                    >
                      {ele?.sold !== undefined && ele?.sold !== null && ele?.sold !== "" ? ele?.sold : "0"}
                    </MDTypography>
                  </MDBox>
                  <MDBox
                    sx={({ palette: { dark, white, info }, breakpoints }) => ({
                      display: "flex",
                      alignItems: "flex-start",
                      justifyContent: "space-between",
                      width: "100%",
                      gap: 3,
                      [breakpoints.up("xs")]: {
                        px: 1,
                      },
                      [breakpoints.up("sm")]: {
                        px: 1,
                      },
                      [breakpoints.up("md")]: {
                        px: 6,
                      },
                      [breakpoints.up("lg")]: {
                        px: 6,
                      },
                    })}
                  >
                    <MDTypography variant="h6" sx={{ minWidth: "200px", flexShrink: 0, whiteSpace: "nowrap", textAlign: "left" }}>
                      Products stock :
                    </MDTypography>
                    <MDTypography
                      variant="h6"
                      sx={{
                        textAlign: "right",
                        maxWidth: "70%",
                      }}
                    >
                      {ele?.stock !== undefined && ele?.stock !== null && ele?.stock !== "" ? ele?.stock : "0"}
                    </MDTypography>
                  </MDBox>
                  <MDBox
                    sx={({ palette: { dark, white, info }, breakpoints }) => ({
                      display: "flex",
                      alignItems: "flex-start",
                      justifyContent: "space-between",
                      width: "100%",
                      gap: 3,
                      [breakpoints.up("xs")]: {
                        px: 1,
                      },
                      [breakpoints.up("sm")]: {
                        px: 1,
                      },
                      [breakpoints.up("md")]: {
                        px: 6,
                      },
                      [breakpoints.up("lg")]: {
                        px: 6,
                      },
                    })}
                  >
                    <MDTypography variant="h6" sx={{ minWidth: "200px", flexShrink: 0, whiteSpace: "nowrap", textAlign: "left" }}>
                      Products features :
                    </MDTypography>
                    <MDTypography
                      variant="h6"
                      sx={{
                        overflow: "hidden",
                        wordBreak: "break-word",
                        textAlign: "right",
                        maxWidth: "70%",
                      }}
                    >
                      {Array.isArray(ele?.features) && ele?.features.length > 0
                        ? ele?.features.filter(Boolean).join(", ") || "-"
                        : (ele?.features || "-")}
                    </MDTypography>
                  </MDBox>
                  <MDBox
                    sx={({ palette: { dark, white, info }, breakpoints }) => ({
                      display: "flex",
                      alignItems: "flex-start",
                      justifyContent: "space-between",
                      width: "100%",
                      gap: 3,
                      [breakpoints.up("xs")]: {
                        px: 1,
                      },
                      [breakpoints.up("sm")]: {
                        px: 1,
                      },
                      [breakpoints.up("md")]: {
                        px: 6,
                      },
                      [breakpoints.up("lg")]: {
                        px: 6,
                      },
                    })}
                  >
                    <MDTypography variant="h6" sx={{ minWidth: "200px", flexShrink: 0, whiteSpace: "nowrap", textAlign: "left" }}>
                      Products Review Rating :
                    </MDTypography>
                    <MDTypography
                      variant="h6"
                      sx={{
                        textAlign: "right",
                        maxWidth: "70%",
                      }}
                    >
                      {ele?.reviewRating || "0"}
                    </MDTypography>
                  </MDBox>
                  <MDBox
                    sx={({ palette: { dark, white, info }, breakpoints }) => ({
                      display: "flex",
                      alignItems: "flex-start",
                      justifyContent: "space-between",
                      width: "100%",
                      gap: 3,
                      [breakpoints.up("xs")]: {
                        px: 1,
                      },
                      [breakpoints.up("sm")]: {
                        px: 1,
                      },
                      [breakpoints.up("md")]: {
                        px: 6,
                      },
                      [breakpoints.up("lg")]: {
                        px: 6,
                      },
                    })}
                  >
                    <MDTypography variant="h6" sx={{ minWidth: "200px", flexShrink: 0, whiteSpace: "nowrap", textAlign: "left" }}>
                      Products Tax Id :
                    </MDTypography>
                    <MDTypography
                      variant="h6"
                      sx={{
                        textAlign: "right",
                        maxWidth: "70%",
                      }}
                    >
                      {ele?.taxId?.taxPercent ? `${ele?.taxId?.taxPercent}%` : (ele?.taxId || "0")}
                    </MDTypography>
                  </MDBox>
                  <MDBox
                    sx={({ palette: { dark, white, info }, breakpoints }) => ({
                      display: "flex",
                      alignItems: "flex-start",
                      justifyContent: "space-between",
                      width: "100%",
                      gap: 3,
                      [breakpoints.up("xs")]: {
                        px: 1,
                      },
                      [breakpoints.up("sm")]: {
                        px: 1,
                      },
                      [breakpoints.up("md")]: {
                        px: 6,
                      },
                      [breakpoints.up("lg")]: {
                        px: 6,
                      },
                    })}
                  >
                    <MDTypography variant="h6" sx={{ minWidth: "200px", flexShrink: 0, whiteSpace: "nowrap", textAlign: "left" }}>
                      Products Time :
                    </MDTypography>
                    <MDTypography
                      variant="h6"
                      sx={{
                        textAlign: "right",
                        maxWidth: "70%",
                      }}
                    >
                      {ele?.time ? `${ele?.time} Min` : "-"}
                    </MDTypography>
                  </MDBox>
                  <MDBox
                    sx={({ palette: { dark, white, info }, breakpoints }) => ({
                      display: "flex",
                      alignItems: "flex-start",
                      justifyContent: "space-between",
                      width: "100%",
                      gap: 3,
                      [breakpoints.up("xs")]: {
                        px: 1,
                      },
                      [breakpoints.up("sm")]: {
                        px: 1,
                      },
                      [breakpoints.up("md")]: {
                        px: 6,
                      },
                      [breakpoints.up("lg")]: {
                        px: 6,
                      },
                    })}
                  >
                    <MDTypography variant="h6" sx={{ minWidth: "200px", flexShrink: 0, whiteSpace: "nowrap", textAlign: "left" }}>
                      Products warranty :
                    </MDTypography>
                    <MDTypography
                      variant="h6"
                      sx={{
                        textAlign: "right",
                        maxWidth: "70%",
                      }}
                    >
                      {ele?.warranty !== undefined && ele?.warranty !== null && ele?.warranty !== ""
                        ? (typeof ele?.warranty === "number" || !isNaN(Number(ele?.warranty))
                            ? `${ele?.warranty} ${Number(ele?.warranty) === 1 ? "Day" : "Days"}`
                            : ele?.warranty)
                        : "-"}
                    </MDTypography>
                  </MDBox>

                  {ele?.images && ele?.images.length > 0 && (
                    <>
                      <MDTypography variant="h6"> Products Image </MDTypography>
                      <SwiperSlider items={1}>
                        {Loading ? (
                          <SkLoading />
                        ) : (
                          ele?.images &&
                          ele?.images.length > 0 &&
                          ele?.images.map((value, index) => (
                            <SwiperSlide key={index}>
                              <MDBox // sx={{ height: "20rem", width: "100%" }}
                                sx={({ breakpoints }) => ({
                                  [breakpoints.up("xs")]: {
                                    height: "10rem",
                                    width: "100%",
                                  },
                                  [breakpoints.up("sm")]: {
                                    height: "10rem",
                                    width: "100%",
                                  },
                                  [breakpoints.up("md")]: {
                                    height: "20rem",
                                    width: "100%",
                                  },
                                  [breakpoints.up("lg")]: {
                                    height: "20rem",
                                    width: "100%",
                                  },
                                })}
                              >
                                <img
                                  src={`${process.env.REACT_APP_URI}/${value?.url}`}
                                  alt="..."
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                    borderRadius: "5px",
                                  }}
                                  onError={(e) => {
                                    e.onerror = null;
                                    e.target.src = require("../../assets/images/bg-sign-in-basic.jpeg");
                                  }}
                                />
                              </MDBox>
                            </SwiperSlide>
                          ))
                        )}
                      </SwiperSlider>
                    </>
                  )}

                  {ele?.additional && ele?.additional.length > 0 && (
                    <>
                      <MDTypography variant="h6"> Products Additional Image </MDTypography>
                      <SwiperSlider items={1}>
                        {Loading ? (
                          <SkLoading />
                        ) : (
                          ele?.additional &&
                          ele?.additional.length > 0 &&
                          ele?.additional.map((value, index) => (
                            <SwiperSlide key={index}>
                              <MDBox // sx={{ height: "20rem", width: "100%" }}
                                sx={({ breakpoints }) => ({
                                  [breakpoints.up("xs")]: {
                                    height: "10rem",
                                    width: "100%",
                                  },
                                  [breakpoints.up("sm")]: {
                                    height: "10rem",
                                    width: "100%",
                                  },
                                  [breakpoints.up("md")]: {
                                    height: "20rem",
                                    width: "100%",
                                  },
                                  [breakpoints.up("lg")]: {
                                    height: "20rem",
                                    width: "100%",
                                  },
                                })}
                              >
                                <img
                                  src={`${process.env.REACT_APP_URI}/${value?.url}`}
                                  alt="..."
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                    borderRadius: "5px",
                                  }}
                                  onError={(e) => {
                                    e.onerror = null;
                                    e.target.src = require("../../assets/images/bg-sign-in-basic.jpeg");
                                  }}
                                />
                              </MDBox>
                            </SwiperSlide>
                          ))
                        )}
                      </SwiperSlider>
                    </>
                  )}

                  {ele?.thumnail ? (
                    <>
                      <MDTypography variant="h6"> Products Thumbnail Image </MDTypography>
                      <MDBox
                        sx={{
                          height: 300,
                          width: "80%",
                        }}
                      >
                        <img
                          src={`${process.env.REACT_APP_URI}/${ele?.thumnail}`}
                          alt="..."
                          style={{ height: "100%", width: "100%", borderRadius: "12px", objectFit: "cover" }}
                          onError={(e) => {
                            e.onerror = null;
                            e.target.src = require("../../assets/images/bg-sign-up-cover.jpeg");
                          }}
                        />
                      </MDBox>
                    </>
                  ) : null}
                </React.Fragment>
              ))}
            </MDBox>
          </MDBox>
        )}
      </MDBox>
    </>
  );
};

export default EproductDeails;
